"use client";

import React from "react";
import { Star } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "John 'Shadow' Smith",
  role: "Pro Gamer",
  hotel: "Apex Predator Rank",
  initials: "AN",
  quote: "The leveling service at P2W is extremely professional. My account rank increased rapidly while ensuring absolute safety. The modern interface and quick payment process are perfect for high-end gaming.",
  rating: 5
}, {
  id: 2,
  name: "Michael 'Dragon' Johnson",
  role: "Guild Master",
  hotel: "Eternal Saga Community",
  initials: "MT",
  quote: "The game item inventory here is the most diverse I've ever seen. Fast transactions and 24/7 support. Very reliable for the professional gaming community. The security system gives me complete peace of mind for high-value trades.",
  rating: 5
}, {
  id: 3,
  name: "Emily 'Cyber' Davis",
  role: "Streamer",
  hotel: "Twitch Partner",
  initials: "LP",
  quote: "The website interface is stunning and smooth. Buying rare skins takes only a few seconds to appear in the inventory. P2W is truly the #1 choice for those who want to elevate their gaming experience without spending too much time grinding.",
  rating: 5
}];
export default function SuccessStoriesFromTheFloor() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}